let date = '7/2/2024'; export default date;
